import store from '../../store'


const isAuthenticatedGuardAuxilio = async (to, from, next) => {
    let ok = false
    let localAuthToken = localStorage.auth_token;
    let cookieExists = localAuthToken !== "undefined" && localAuthToken !== null;
    if (cookieExists) {
        const auth_token = localStorage.getItem("auth_token");
        const authTokenExists = auth_token !== "undefined" && auth_token !== null;
        if (authTokenExists)
            ok = await store.dispatch('auth/loginUserWithToken', { auth_token })
    }
    if (ok) {
        if (store.getters['auth/getUserRol'] === "Administrador" || store.getters['auth/getUserRol'] === "Panel Auxilio Vial")
            next()
        else
            next({ name: 'Meta' })
    }
    else next({ name: 'Meta' })
}

export default isAuthenticatedGuardAuxilio